import { mapGetters } from 'vuex';
import { Fragment } from 'vue-fragment';

/* TEMPLATE OF DYNAMIC ICON, HOW IT SHOULD RENDERED IN ICON COMPOENNT
<div
v-if="handledHtmlIconCode('favourite_icon')"
v-html="handledHtmlIconCode('favourite_icon')"
:style="'display: contents'"
></div>

RENDER THE STATIC ICON
<svg v-else></svg>
*/

export default {
    data() {
        return {
            testIcon: `<svg fill="#000000" height="800px" id="Layer_1" version="1.1" viewBox="0 0 455 455" width="800px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M326.632,10.346c-38.733,0-74.991,17.537-99.132,46.92c-24.141-29.383-60.399-46.92-99.132-46.92  C57.586,10.346,0,67.931,0,138.714c0,55.426,33.049,119.535,98.23,190.546c50.162,54.649,104.729,96.96,120.257,108.626l9.01,6.769  l9.009-6.768c15.53-11.667,70.099-53.979,120.26-108.625C421.95,258.251,455,194.141,455,138.714  C455,67.931,397.414,10.346,326.632,10.346z"/></svg>`
        };
    },
    components: { Fragment },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings'
        })
    },
    methods: {
        fixSvgNamespace(svgString) {
            svgString = svgString?.replace(/xmlns:="http:\/\/www\.w3\.org\/2000\/svg"/g, 'xmlns="http://www.w3.org/2000/svg"');

            svgString = svgString?.replace(/(<image\b[^>]*?)\s+alt="[^"]*"/g, '$1');

            return svgString;
        },
        handleIconCode(iconCode) {
            if (iconCode) return iconCode?.replace(/\sfill="[^"]*"/g, '');
            else return null;
        },
        handledHtmlIconCode(iconKeyName) {
            const iconCode = this.globalSettings?.additional_settings?.[iconKeyName] || null;

            if (iconKeyName === 'favourite_icon') {
                if (iconCode) return this.fixSvgNamespace(iconCode);
                else return null;
            } else {
                if (iconCode) return this.handleIconCode(this.fixSvgNamespace(iconCode));
                else return null;
            }
        }
    },
    mounted() {}
};
